
    /**
     *  Начать загрузку страницы
     */
    window.pageLoadingStart = function () {

        $('body').addClass('page-loading');

    };


    /**
     * загрузка страницы без стилей
     */
    window.pageLoadingWithoutStyle = function (){
        $('body.page-loading').addClass('page-loading-without-style');
    }


    /**
     *  Закончить загрузку страницы
     */
    window.pageLoadingEnd = function () {

        $('body').removeClass('page-loading').removeClass('page-loading-without-style');

    };



    /**
     *  Проверить идет ли сейчас загрузка страницы
     */
    window.isPageLoadingNow = function () {

        if( $('body').hasClass('page-loading') )
            return true;

        return  false;

    };


    /**
     *  Загрузка страницы инициализация скриптов (функция срабатывает при каждой загрузке страницы через ajax)
     */
    window.pageInit = function ( first_load = false ){
        select2Setup();
        iframeResize();
        fileUploadSetup();
        setUpCitySelectField();
        initDatePicker();

        if( !first_load ){

            setTimeout(function(){

                window.dispatchEvent( new Event("load") );

            }, 100);

        }

    };
    pageInit( true );
